import React, { useCallback } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { useTransferComment } from '@bcraft-frontend-lib/payments'
import block from 'bem-cn'

import { openChat } from 'shared/utils/liveChat'

import { selectLocaleDict } from 'features/locale/selectors'

import Button from 'components/UIKit/Button/Button'

import './TransferComment.scss'

const b = block('transfer-comment')

export const TransferComment: React.FC<{}> = () => {
  const { common, profile } = useSelector(selectLocaleDict, shallowEqual)

  const { onClose, currentTransfer } = useTransferComment()

  const onSupportClick = useCallback(() => {
    openChat()
    onClose()
  }, [onClose])

  return (
    <div className={b()}>
      <div className={b('header')}>
        {common.description}
        <span onClick={onClose} className={b('header-close')}>
          <div className={b('header-close-icon')}>×</div>
        </span>
      </div>
      <div className={b('text')}>{currentTransfer?.comment ? currentTransfer.comment : profile.empty}</div>
      <div className={b('buttons')}>
        <div className={b('button-wrapper')}>
          <Button onClick={onSupportClick}>{common.support}</Button>
        </div>
        <div className={b('button-wrapper')}>
          <Button text={common.close} onClick={onClose} />
        </div>
      </div>
    </div>
  )
}
